// extracted by mini-css-extract-plugin
export default {"button":"Invites-module__button__TYI9K"};